import { render, staticRenderFns } from "./InfoDialog.html?vue&type=template&id=1c4c23c0&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./InfoDialog.scss?vue&type=style&index=0&id=1c4c23c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c23c0",
  null
  
)

export default component.exports